import ApiService from '@/services/core/api.service'

const AdminWarehouseService = {
  async get (query) {
    return ApiService.get(`admin/warehouses?${query}`)
  }
}

export default AdminWarehouseService
